import React from "react";
import {
    Checkbox, createMuiTheme,
    FormControl, FormControlLabel,
    FormGroup,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    withStyles
} from "@material-ui/core";
import {ThemeProvider} from "@material-ui/styles";
import {isSuperUser} from "../../sc-utilities";
import {KeyboardDatePicker} from "@material-ui/pickers";
import {getDateFormat} from "../../sc-utilities/date";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        width: '120px',
        marginTop: '10px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    cancel: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: '100%'
    },
    datePicker: {
        width: '100%'
    }
});

const defaultMaterialThemeAdmin = createMuiTheme({
    palette: {
        primary: { 500: '#0C5A99' }
    }
});

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: { 500: '#7dc5e2' }
    }
});

const PlanFormDetails = (props) => {
    const {values, translations, errors, touched, handleChange, handleBlur, classes, statuses, setFieldValue, isEdit} = props;

    return (
       <>
        <TextField
            name="Name"
            value={values.Name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!(errors.Name && touched.Name)}
            placeholder={translations["plan_name"] || 'Plan name'}
            label={translations["plan_name"] || 'Plan name'}
            margin={'dense'}
            fullWidth={true}
        />
        <TextField
            name="Description"
            value={values.Description}
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!(errors.Description && touched.Description)}
            placeholder={translations["description"] || 'Description'}
            label={translations["description"] || 'Description'}
            margin={'dense'}
            fullWidth={true}
        />
        <FormControl className={classes.formControl} margin={'dense'}>
            <InputLabel shrink>{translations["billing_account_status_text"] || "Please select billing account status"}</InputLabel>
            <Select name="Status" margin={'dense'} value={values.Status} onChange={handleChange}>
                {(statuses ? [...statuses] : []).map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.displayValue}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
        <ThemeProvider theme={isSuperUser() ? defaultMaterialThemeAdmin : defaultMaterialTheme}>
            <FormHelperText>{translations["valid_from"] || 'Valid from'}</FormHelperText>
            <KeyboardDatePicker
                className={classes.datePicker}
                clearable={true}
                onChange={date => setFieldValue('ValidFrom', date)}
                format={getDateFormat()}
                value={values.ValidFrom}
                margin="dense"
                placeholder={translations["activation_date_text"] || 'Please select from which day plan will be active (default is now)'}
            />
            {props.formHelperTextBottom ? <FormHelperText>{props.formHelperTextBottom}</FormHelperText> : null}
        </ThemeProvider>

        <ThemeProvider theme={isSuperUser() ? defaultMaterialThemeAdmin : defaultMaterialTheme}>
            <FormHelperText>{translations["valid_to"] || 'ValidTo'}</FormHelperText>
            <KeyboardDatePicker
                className={classes.datePicker}
                clearable={true}
                onChange={date => setFieldValue('ValidTo', date)}
                format={getDateFormat()}
                value={values.ValidTo}
                margin="dense"
                placeholder={translations["no_expiration_date_text"] || 'Please select expire date (leave empty if plan does not have expiration date)'}
                disablePast={true}
            />
            {props.formHelperTextBottom ? <FormHelperText>{props.formHelperTextBottom}</FormHelperText> : null}
        </ThemeProvider>
        <FormGroup>
            <FormControlLabel control={
                <Checkbox
                    color="primary"
                    margin={"dense"}
                    name={"PrepaidAllowed"}
                    checked={values.PrepaidAllowed}
                    onChange={handleChange}
                    disabled={isEdit}
                />
            }
                label={translations["prepaid_usage_allowed"] || "Allow for prepaid usage"}/>
            <FormControlLabel
                control={
                    <Checkbox
                        color="primary"
                        margin={"dense"}
                        name={"PostpaidAllowed"}
                        checked={values.PostpaidAllowed}
                        onChange={handleChange}
                        disabled={isEdit}
                    />
                }
                label={translations["postpaid_usage_allowed"] || "Allow for postpaid usage"}
            />
        </FormGroup>
       </>
    )
}

export default withStyles(styles, { withTheme: true })(PlanFormDetails);
